import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";
import { ConfirmerRequestItem } from "src/app/corporate/core/model/confirmer-credit";

@Component({
  selector: "app-confirm-credit-modal",
  templateUrl: "./confirm-credit-modal.component.html",
  styleUrls: ["./confirm-credit-modal.component.scss"],
})
export class ConfirmCreditModalComponent implements OnInit {
  @Input() requestItemId;
  @Input() workflowCode;

  requestItem: RequestItem;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  confirmerRequestItem: ConfirmerRequestItem = new ConfirmerRequestItem();

  constructor(
    private _requestItemService: RequestItemService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      montantAccorde: [null, Validators.compose([Validators.required])],
      tauxAccorde: [null, Validators.compose([Validators.required])],
      echeanceAccorde: [null, Validators.compose([Validators.required])],
      commissionEngagementAccorde: [
        null,
        Validators.compose([Validators.required]),
      ],
      typeTirage: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getRequestItemById(this.requestItemId);
  }

  getRequestItemById(requestItemId) {
    this._requestItemService.getRequestItemById(requestItemId).subscribe(
      (data) => {
        this.requestItem = data;

        this.confirmerRequestItem.montantAccorde = this.requestItem.montant;
        this.confirmerRequestItem.tauxAccorde = this.requestItem.taux;
        this.confirmerRequestItem.echeanceAccorde = this.requestItem.echeance;
        this.confirmerRequestItem.typeTirage = this.requestItem.typeTirage;
        this.confirmerRequestItem.commissionEngagementAccorde =
          this.requestItem.commissionEngagement;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();

    this.confirmerRequestItem.requestItemId = this.requestItemId;

    this._requestItemService
      .confirmer(this.confirmerRequestItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
